import { EligibleVoucherData } from "modules/voucher";
import { formatCurrency } from "./string";

export const voucherTypeChecker = (voucherData?: EligibleVoucherData) => {
  switch (voucherData?.discount_type) {
    case "percentage":
      return {
        ...voucherData,
        amount: `${Math.floor(Number(voucherData?.amount))}%`,
      };
    case "amount": {
      return {
        ...voucherData,
      };
    }
    default:
      return voucherData;
  }
};

export const capAmountIsValid = (cap?: number | string) =>
  cap !== undefined && cap !== null && Number(cap) > 0;
